export const DISCIPLINARY_OUTCOMES = ["Strong Warning", "Suspension", "Expulsion"];

export const DISCIPLINARY_OFFENSE_CATEGORIES = [
    "Fighting / assault",
    "Bullying / harassment",
    "Theft / vandalism",
    "Truancy / absconding",
    "Disrespect / insubordination",
    "Cheating / exam malpractice",
    "Substance abuse",
    "Uniform / dress code",
    "Other",
];

export const DISCIPLINARY_STATUS_CHIP = {
    Pending: "warning",
    Verified: "success",
    Rejected: "error",
};
